import BaseComponent from './BaseComponent';

class Table extends BaseComponent {

    parseRows(){
	var rowCount=0;
	return this.props.config.items !== undefined? this.props.config.items.map((item,idx) => {
		rowCount++;

		const extra_data = this.props.config.extra_data !== undefined?this.props.config.extra_data[idx]:undefined
		return (
			<tr key={item.id+'_'+idx}>
				{this.parseCols(rowCount, item, extra_data)}
			</tr>
		)
	}):undefined;
    }

    parseCols(row, item, extra_data){
	let colCount = 0;
	return	this.props.config.mapping.map((mapping,idx) => {
		if(!mapping.visible) return false;
		colCount++;
		
		const tdClassName = "p-1"+
			(mapping.textRight?' text-right':mapping.textCenter?' text-center':'') +
			(mapping.bold?' font-weight-bold':'')
		return (
			<td key={row+'-'+colCount+'_'+idx} className={tdClassName} 
			style={mapping.click?this.cursorPointer: undefined} 
			onClick={mapping.click?this.parseOnClick.bind(this,item,mapping.click): undefined}>
				{mapping.display === undefined || mapping.display === 'default'?
					this.getTrad(item[mapping.original])
				:(mapping.display === 'check'?<input type='checkbox' onChange={mapping.change_callback} 
					checked={this.props.config.checked && this.props.config.checked.indexOf(item[mapping.original]) !== -1?'checked':undefined}
					disabled={this.props.config.disabled && this.props.config.disabled.indexOf(item[mapping.original]) !== -1?'checked':undefined}
					name={(mapping.prefix !== undefined?mapping.prefix:'')+item[mapping.original]} />
								
				:mapping.display === 'button'?<button type="button" className="btn-xs btn-primary" 
				name={mapping.prefix+item[mapping.original]}
				id={mapping.prefix+item[mapping.original]}
				onClick={mapping.click_callback}>
				{mapping.button?mapping.button:item[mapping.original]}
				</button>
				:mapping.display === 'extra_data'?extra_data[mapping.extra_data.value]//[mapping.extra_data.value]
				:'Column type not defined')
				}
			</td>
		);
	});
    }

    parseOnClick(item,click){
    	if(!click) return;
	let url = click.url;
	if(click.params && click.params.length > 0 ){
		url +='?';
		click.params.forEach(function (param, index){
			url += param.name+'='+item[param.field];
		})
	}
	if(click) this.navigateTo(url);
    }

    parseHeaders(){
	let colCount = 0;
	return	this.props.config.mapping.map((mapping,idx) => {
		if(!mapping.visible) return false;
		colCount++;
		return (
			<th key={'th-'+colCount+'_'+idx} scope="col" >{mapping.shown}</th> 
		);
	});
    }

    parsePagination(){

	return this.props.config.pagination?
  	<ul className="pagination">
		{this.props.config.pagination.currentPage>1?
		<li className="page-item">
      			<a className="page-link" href="dummie" aria-label="Previous"  
      			onClick={(e) => {e.preventDefault();this.pageClickHandler(this.props.config.pagination.currentPage -1, e)}}>
        			<span aria-hidden="true">&laquo;</span>
        			<span className="sr-only">Previous</span>
      			</a>
    		</li>
    		:''
		}
		{this.parsePaginationOptions()}
		{this.props.config.pagination.currentPage<this.props.config.pagination.totalPages?
		<li className="page-item">
			<a className="page-link" href="dummie" aria-label="Next" 
			onClick={(e) => {e.preventDefault();this.pageClickHandler(this.props.config.pagination.currentPage+1, e)}}>
				<span aria-hidden="true">&raquo;</span>
				<span className="sr-only">Next</span>
			</a>
		</li>
		:''}

	</ul>
	:''
    }

    parsePaginationOptions(){

	let buttons = [];
	const init = this.props.config.pagination.currentPage-3<=0?1:this.props.config.pagination.currentPage-3;
	const max = this.props.config.pagination.currentPage+3>=this.props.config.pagination.totalPages?
			this.props.config.pagination.totalPages:this.props.config.pagination.currentPage+3;
	for(let i= init;i<=max;i++){
		buttons.push(i);
	}
	if(buttons.length === 0) buttons.push(1);
	return buttons.map((elem,index) => {
		return <li key={'pag_'+index} className={elem===this.props.config.pagination.currentPage?"page-item active":"page-item"}>
				<a className="page-link" href="dummie" onClick={(e) => {e.preventDefault();this.pageClickHandler(elem, e)}}>{elem}</a>
			</li>
	})
    }

    pageClickHandler(pageNumber, event){
	this.props.config.pagination.callback(pageNumber);
    }

    //se sobreescribe el metodo para cambiar state por props
    getTrad(key, domain){
	return this.props.config.i18n!== undefined?this.getI18n(this.props.config.i18n, key, domain):'';
    }

    render() {
    	return (
<>
		<table className="table table-striped table-hover">
			<thead>
				<tr>
					{this.parseHeaders()}
				</tr>
			</thead>
			<tbody>

				{this.parseRows()}
			</tbody>
		</table>

		{this.parsePagination()}

</>
        )
    }

    cursorPointer = {
	cursor:"pointer"
    }
}

export default Table;
